import { analysisClient } from "@/shared/lib/supabase";

export const analysisSetting = {
  updateMetadata: (
    analysisId: string,
    values: { displayName: string; context: string },
  ) =>
    analysisClient
      .from("analysis_setting")
      .update({
        display_name: values.displayName,
        display_description: values.context,
      })
      .eq("analysis_id", analysisId)
      .select("*")
      .single(),
};
